import { render, staticRenderFns } from "./Unapproved.vue?vue&type=template&id=3e20d48d&scoped=true&"
import script from "./Unapproved.vue?vue&type=script&lang=js&"
export * from "./Unapproved.vue?vue&type=script&lang=js&"
import style0 from "./Unapproved.vue?vue&type=style&index=0&id=3e20d48d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e20d48d",
  null
  
)

export default component.exports